export const MAINTENANCE_WINDOW_PATH = 'maintenance-window';

/** True when `url` (as reported by the router) points at the blank maintenance page. */
export function isMaintenanceWindowUrl(url: string): boolean {
  return url.split('?')[0].replace(/^\/+/, '') === MAINTENANCE_WINDOW_PATH;
}
